function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M16,24c3.6,0,7.1,0.7,10.2,2.1c1.8-2.2,2.8-5,2.8-8.1c0-7.2-5.8-13-13-13S3,10.8,3,18c0,3.1,1.1,5.9,2.8,8.1 C8.9,24.7,12.4,24,16,24z"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 16,
  y1: 8,
  x2: 16,
  y2: 10
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 8.9,
  y1: 10.9,
  x2: 10.3,
  y2: 12.3
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 6,
  y1: 18,
  x2: 8,
  y2: 18
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 26,
  y1: 18,
  x2: 24,
  y2: 18
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 23.1,
  y1: 10.9,
  x2: 21.7,
  y2: 12.3
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 16,
  y1: 24,
  x2: 20,
  y2: 16
});

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.8b76faa9.svg";
export { ForwardRef as ReactComponent };